module.exports = __webpack_public_path__ + "img/icon1.f778313d.png";